<template>
  <div class="space-y-5">
    <!-- Section header -->
    <div class="flex items-center gap-3">
      <span
        class="flex items-center justify-center flex-shrink-0 rounded-lg w-9 h-9 bg-taxiye-100 text-taxiye-500"
      >
        <span class="material-icons-round">badge</span>
      </span>
      <div class="min-w-0">
        <h3 class="text-base font-semibold text-gray-800">Corporate Profile</h3>
        <p class="text-sm text-gray-500 truncate">{{ corporate._id }}</p>
      </div>
    </div>

    <form @submit.prevent="update" class="space-y-5">
      <div class="p-5 space-y-4 border border-gray-200 bg-gray-50 rounded-2xl">
        <div class="grid grid-cols-2 gap-4">
          <label class="block">
            <span class="text-sm font-medium text-gray-600">Name</span>
            <input
              v-model="corporate.name"
              class="w-full mt-1 border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300 text-sm"
              placeholder="Sheraton Addis"
            />
          </label>
          <label class="block">
            <span class="text-sm font-medium text-gray-600">Short Name</span>
            <input
              :value="corporate.shortName"
              minlength="3"
              maxlength="3"
              disabled
              class="w-full mt-1 text-gray-500 border-gray-300 shadow-sm form-input rounded-xl bg-gray-100 cursor-not-allowed text-sm"
              placeholder="SHR"
            />
          </label>
        </div>

        <div class="grid grid-cols-2 gap-4">
          <label class="block">
            <span class="text-sm font-medium text-gray-600">Email</span>
            <input
              v-model="email"
              class="w-full mt-1 border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300 text-sm"
              placeholder="email"
            />
          </label>
        </div>
      </div>

      <div v-if="changed">
        <button
          :disabled="busy"
          class="inline-flex items-center justify-center h-10 px-4 text-sm font-semibold text-white transition-colors duration-150 rounded-xl shadow-sm"
          :class="
            busy
              ? 'bg-taxiye-200 cursor-not-allowed'
              : 'bg-taxiye-500 hover:bg-taxiye-600'
          "
        >
          <span class="mr-1 text-base material-icons-round">save</span>
          Update
        </button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: ["corporate"],
  data() {
    return {
      busy: false,
      name: "",
      email: "",
    };
  },
  mounted() {
    this.name = this.corporate.name;
    this.email = this.corporate.email;
  },
  computed: {
    changed() {
      const nameChanged = this.corporate.name != this.name ? true : false;
      const emailChanged = this.corporate.email != this.email ? true : false;

      return nameChanged || emailChanged;
    },
  },
  watch: {
    corporate() {
      this.name = this.corporate.name;
      this.email = this.corporate.email;
    },
  },
  methods: {
    update() {
      if (this.corporate.name) {
        this.busy = true;
        this.$http
          .patch("/corporates/" + this.corporate._id, {
            name: this.name,
            email: this.email,
          })
          .then(() =>
            window.flash({ body: "Profile updated!", type: "success" })
          )
          .catch(err => console.log(err))
          .finally(() => (this.busy = false));
      }
    },
  },
};
</script>
